// cart-chip.js
if (window.__CART_CHIP_INIT__) {
  /* no-op */
} else {
  window.__CART_CHIP_INIT__ = true;
  (function () {
    // --- readiness ----------------------------------------------------------
    function ready(cb) {
      if (typeof PUB_SUB_EVENTS !== 'undefined' && window.Shopify?.pubsub) cb();
      else setTimeout(() => ready(cb), 50);
    }

    // --- state --------------------------------------------------------------
    let lastCount = 0;
    let rafId = null;
    let inflight = null;
    let fetchTimer = null;

    // --- dom helpers --------------------------------------------------------
    const $chips = () => document.querySelectorAll('.cart-chip, [data-cart-count]');

    function setCountOnEl(el, count) {
      if (el.hasAttribute('data-cart-count')) {
        el.setAttribute('data-cart-count', String(count));
      } else {
        const target = el.querySelector('[data-cart-count-target]') || el;
        target.textContent = String(count);
      }
      el.classList.toggle('active', count > 0);
      el.setAttribute('aria-live', 'polite');
    }

    function paint(count) {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        $chips().forEach((el) => setCountOnEl(el, count));
      });
    }

    function render(count) {
      const n = Number(count) || 0;
      if (n === lastCount) {
        if ($chips().length) paint(n); // repaint for newly inserted chips
        return;
      }
      lastCount = n;
      paint(n);
    }

    // --- count sources ------------------------------------------------------
    function deriveCount(ev) {
      if (typeof ev?.cartData?.item_count === 'number') return ev.cartData.item_count;
      if (typeof ev?.item_count === 'number') return ev.item_count;
      if (Array.isArray(ev?.items)) return ev.items.reduce((s, it) => s + (Number(it?.quantity) || 0), 0);
      return null;
    }

    function fetchCartCount() {
      if (inflight) return inflight;
      inflight = fetch('/cart.js')
        .then((r) => {
          if (!r.ok) throw new Error('Cart fetch failed');
          return r.json();
        })
        .then((cart) => cart?.item_count ?? 0)
        .catch(() => lastCount)
        .finally(() => {
          inflight = null;
        });
      return inflight;
    }

    function scheduleFetchAndRender(delay = 120) {
      clearTimeout(fetchTimer);
      fetchTimer = setTimeout(() => {
        fetchCartCount().then((c) => render(c));
      }, delay);
    }

    // --- observers & lifecycle ---------------------------------------------
    const mo = new MutationObserver(() => {
      if ($chips().length) paint(lastCount);
    });
    function startObserver() {
      if (document.body) {
        mo.observe(document.body, { childList: true, subtree: true });
      } else {
        window.addEventListener('DOMContentLoaded', () =>
          mo.observe(document.body, { childList: true, subtree: true })
        );
      }
    }
    startObserver();

    document.addEventListener('shopify:section:load', () => paint(lastCount));
    document.addEventListener('shopify:section:unload', () => paint(lastCount));

    window.addEventListener('pageshow', () => scheduleFetchAndRender(0));
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') scheduleFetchAndRender(0);
    });

    // --- wire up ------------------------------------------------------------
    ready(() => {
      // Authoritative updates from cart.js
      Shopify.pubsub.subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
        const c = deriveCount(ev);
        if (typeof c === 'number') render(c);
        else scheduleFetchAndRender();
      });

      // Optimistic updates from UI
      Shopify.pubsub.subscribe(PUB_SUB_EVENTS.quantityUpdate, (ev) => {
        if (typeof ev?.delta === 'number' && ev.delta !== 0) {
          const optimistic = Math.max(0, lastCount + ev.delta);
          render(optimistic);
          return;
        }
        const c = deriveCount(ev);
        if (typeof c === 'number') render(c);
      });

      scheduleFetchAndRender(0);
    });
  })();
}
